import React, { Component, Fragment } from "react";
import moment from "moment";
import {
  Metric,
  Error,
  isDateFromDataInISOFormat,
  formatDateFromData,
} from "components/Utils/Utils.js";

import SharedSocialLineChart from "components/Graphs/LineGraphs/SharedSocialLineChart/SharedSocialLineChart";
import { fetchInsights } from "components/Utils/InsightsUtils";

class HearstTrendingDisplayImpressions extends Component {
  constructor() {
    super();
    this.state = {
      widgetsInsights: [],
    };
  }
  componentDidMount() {
    this.props.childRef(this);

    const { data, project_id, project, insights, insightsConfig } = this.props;
    if (insights) {
      const insightsPromise = fetchInsights(
        data,
        project,
        project_id,
        insightsConfig
      );

      if (insightsPromise !== undefined) {
        insightsPromise
          .then((data) => {
            if (data && data.length > 0) {
              this.setState({
                widgetsInsights: data,
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  }

  getExportData = () => {
    const data = this.childRef.getExportData().data.map((e) => ({
      ...e,
      name: e.full_date || e.date || e.name,
    }));
    return {
      data: data,
      opts: {
        type: "chart",
        date: {
          name: "name",
          // overwrites the default settings for date only when the date is in ISO format
          defined: isDateFromDataInISOFormat(data),
          format: "YYYY-MM-DDThh:mm:ssZ",
          viewFormat: "YYYY-MM-DD",
        },
        values: ["current_value", "previous_value"],
      },
    };
  };

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={290} />;
    }

    let preparedData = formatDateFromData(
      this.props.data.data.chart.map((e) => ({
        ...e,
        full_date: moment.utc(e.current_date).format("MM/DD"),
        name: moment.utc(e.current_date).format("MM/DD"),
        today: e.current_value,
        yesterday: e.previous_value,
      })),
      null,
      "name"
    );

    return (
      <Fragment>
        <div className="row mb-4">
          <div className="col">
            <Metric {...data.data.display_impressions} size={"lg"} />{" "}
          </div>{" "}
        </div>
        <SharedSocialLineChart
          ref={(el) => (this.childRef = el)}
          data={preparedData}
          color={"#F3108E"}
          widgetsInsights={this.state.widgetsInsights}
        />
      </Fragment>
    );
  }
}

export default HearstTrendingDisplayImpressions;
